import "./App.css";
import { Routes, Route, Link, BrowserRouter as Router } from "react-router-dom";
import React, { Component } from "react";
import MainPage from "./pages/mainPage/mainPage";
import SignUpPage from "./pages/signupPage/signupPage";
import AppBar from "./components/organisms/appBar/appBar";
import { AppProvider } from "./AppContext";
import LoginPage from "./pages/loginPage/loginPage";
import ProfilePage from "./pages/profilePage/profilPage";
import NotFoundPage from "./pages/404/notFoundPage";
import PaymentResultPage from "./pages/paymentResultPage/paymentResultPage";
import AdminPage from "./pages/adminPage/adminPage";
import FAQPage from "./pages/faqPage/faqPage";
import BulkPaymentPage from "./pages/bulkPaymentPage/bulkPaymentPage";
import GirisPage from "./pages/girisPage/girisPage";

const headerLogos = (
  <div className="headerRow">
    <Link to="/">
      <img
        style={{ width: 200 }}
        className="left-logo"
        src="/assets/images/logo.png"
      />
    </Link>
    <h1 className="header-text">XII. ZEKA VE YETENEK KONGRESİ BAŞVURU EKRANI</h1>
  </div>
);

class App extends Component {
  render() {
    return (
      <AppProvider>
        <Router>
          <div className="App">
            {headerLogos}
            <AppBar />
            <div className="content">
              <Routes>
                <Route exact path="/" element={<MainPage />} />
                <Route path="/bulk-payment" element={<BulkPaymentPage />} />
                <Route exact path="login" element={<LoginPage />} />
                <Route exact path="signup" element={<SignUpPage />} />
                <Route exact path="profile" element={<ProfilePage />} />
                <Route exact path="admin" element={<AdminPage />} />
                <Route exact path="sss" element={<FAQPage />} />
                <Route path="giris/:key" element={<GirisPage />} />
                <Route
                  exact
                  path="payment_result"
                  element={<PaymentResultPage />}
                />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </div>
            <footer className="footer">
              <div>
                <img
                  src="/assets/images/is-bank.png"
                  style={{
                    marginTop: 30,
                    height: 70,
                    maxWidth: 250,
                    marginBottom: 40,
                  }}
                />
              </div>
              <div>
                <a
                  href="https://www.tzv.org.tr"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="/assets/images/tzv-logo1.png"
                    style={{
                      marginTop: 30,

                      maxWidth: 250,
                    }}
                  />
                </a>
              </div>
            </footer>
          </div>
        </Router>
      </AppProvider>
    );
  }
}

export default App;
